import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CoffeeLogo from '../images/logo.svg';
import './Header.css';
import CartIcon from '../images/cart.svg';
import UserDetails from './UserDetails';

function Header({ cart }) {
  const cartQuantity = cart.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <header className="header-component">
      <Link to="/">
        <img src={CoffeeLogo} alt="logo" />
        <h1>Code Cafe</h1>
      </Link>
      <div className="menu">
        <Link to="/cart">
          <img src={CartIcon} alt="cart" />
          <div className="badge" data-testid="cart-quantity">{cartQuantity}</div>
        </Link>
        <UserDetails />
      </div>
    </header>
  );
}

Header.propTypes = {
  cart: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
  })).isRequired,
};

export default Header;
